export const IS_LOADING = "IS_LOADING";
export const RESET_FILE_STORE = "RESET_FILE_STORE";
